import { motion, useInView } from 'motion/react';
import { PropsWithChildren, useRef } from 'react';
import styled from 'styled-components';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionProjectSliderCardProps extends PropsWithChildren {
  className?: string;
}

export const MotionProjectSliderCard = ({
  children,
  className,
}: MotionProjectSliderCardProps) => {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    amount: ANIMATION_CONFIG.sliderProject.amount,
  });

  return (
    <MotionProjectSliderCardWrapper
      className={className}
      ref={ref}
      initial={{ opacity: 0, scale: ANIMATION_CONFIG.sliderProject.scale }}
      animate={
        inView
          ? { opacity: 1, scale: 1 }
          : { opacity: 0, scale: ANIMATION_CONFIG.sliderProject.scale }
      }
      transition={{ duration: ANIMATION_CONFIG.sliderProject.duration }}
    >
      {children}
    </MotionProjectSliderCardWrapper>
  );
};

const MotionProjectSliderCardWrapper = styled(motion.div)``;
